import { IRootState } from '../../../store'
import { ISubmitChartState } from '../store/submitChart.types'

export const getSubmitChartSelector = (state: IRootState): ISubmitChartState => state.submitChart
